var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1911_12105)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1911_12105)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1911_12105",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 26,
    width: 64,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8335 26.9195V39.9482H65.1668V26.9195",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1911_12105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.83374 26.88V39.7363H7.36202V37.6446H5.08829V33.7495H6.88829V31.6386H5.08829V28.9715H7.36202V26.88H2.83374Z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1911_12105",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 26,
    width: 64,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8335 26.9195V39.9482H65.1668V26.9195",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1911_12105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.70312 29.9694H9.74934V30.4874C10.0145 30.1037 10.5072 29.8541 11.1514 29.8541C12.4587 29.8541 12.6291 30.4297 12.6291 32.0992V39.7363H10.564V32.4446C10.564 31.9456 10.4693 31.869 10.2041 31.869C9.91979 31.869 9.74934 31.9265 9.74934 32.4446V39.7363H7.70312V29.9694Z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1911_12105",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 26,
    width: 64,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8335 26.9195V39.9482H65.1668V26.9195",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1911_12105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9514 29.966H13.5007V27.5865H15.5279V29.966H16.2289V31.9231H15.5279V37.0656C15.5279 37.6798 15.6986 37.7758 16.1342 37.7758H16.2289V39.7324H15.509C14.107 39.7324 13.5007 39.1569 13.5007 37.5451V31.9228H12.9514V29.966Z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1911_12105",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 26,
    width: 64,
    height: 14
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8335 26.9195V39.9482H65.1668V26.9195",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1911_12105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9956 39.793C20.8903 39.793 21.2504 38.8334 21.2883 36.7803L19.3936 36.6845C19.3936 37.7781 19.2421 37.9316 18.9199 37.9316C18.5979 37.9316 18.4464 37.7206 18.4464 36.838V35.6674H21.3072V32.8274C21.3072 30.7168 20.7578 29.8533 18.9956 29.8533C17.1959 29.8533 16.4949 30.5441 16.4949 32.8468V36.838C16.4949 38.8912 17.0633 39.793 18.9956 39.793ZM18.4464 32.8274C18.4464 31.9834 18.5979 31.7913 18.9388 31.7913C19.2989 31.7913 19.4126 31.9834 19.4126 32.8083V33.883H18.4464V32.8274Z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1911_12105",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 26,
    width: 64,
    height: 14
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8335 26.9195V39.9482H65.1668V26.9195",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1911_12105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.78 29.9694H23.8262V30.5449C24.0538 30.1995 24.4136 29.9885 24.6601 29.9694V31.9456C24.1106 31.9842 23.8262 32.1183 23.8262 33.4807V39.7363H21.78V29.9694Z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1911_12105",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 26,
    width: 64,
    height: 14
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8335 26.9195V39.9482H65.1668V26.9195",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1911_12105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8506 29.966H25.3243V27.5865H27.3513V29.966H28.0715V31.9614H27.3513V37.0656C27.3513 37.6798 27.5221 37.7758 27.9577 37.7758H28.0715V39.7324H27.3324C25.9304 39.7324 25.3243 39.1569 25.3243 37.5451V31.9611H24.8506V29.966Z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1911_12105",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 26,
    width: 64,
    height: 14
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8335 26.9195V39.9482H65.1668V26.9195",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1911_12105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7383 39.7539C30.6297 39.7539 30.9504 39.6389 31.1398 39.255V39.7347H33.0337V32.1553C33.0337 30.409 32.6752 29.8526 30.7989 29.8526C29.0565 29.8526 28.3368 30.6586 28.2231 32.328L30.1726 32.539C30.2105 32.021 30.2484 31.7905 30.7055 31.7905C31.0464 31.7905 31.1019 31.9249 31.1019 32.5007V32.8461C28.7332 33.4792 28.2408 34.4387 28.2408 36.9716C28.2408 38.9862 28.4125 39.7539 29.7383 39.7539ZM30.5918 37.9886C30.2484 37.9886 30.1928 37.6816 30.1928 36.8181C30.1928 35.3788 30.3999 35.0911 31.1019 34.8224V37.1057C31.1019 37.8543 30.9883 37.9886 30.5918 37.9886Z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1911_12105",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 26,
    width: 64,
    height: 14
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8335 26.9195V39.9482H65.1668V26.9195",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1911_12105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6218 27.5899H35.6294V29.6623H33.6218V27.5899ZM33.6218 29.9694H35.6294V39.7363H33.6218V29.9694Z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1911_12105",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 26,
    width: 64,
    height: 14
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8335 26.9195V39.9482H65.1668V26.9195",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1911_12105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2556 29.9694H38.3011V30.4874C38.5662 30.1037 39.0586 29.8541 39.7026 29.8541C41.0107 29.8541 41.1622 30.4297 41.1622 32.0992V39.7363H39.1167V32.4446C39.1167 31.9456 39.0208 31.869 38.7556 31.869C38.4728 31.869 38.3011 31.9265 38.3011 32.4446V39.7363H36.2556V29.9694Z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1911_12105",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 26,
    width: 64,
    height: 14
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8335 26.9195V39.9482H65.1668V26.9195",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1911_12105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.3189 32.4446C47.3189 31.9456 47.2432 31.869 46.978 31.869C46.6371 31.869 46.5613 32.0034 46.5613 32.4446V39.7363H44.5361V32.4446C44.5361 31.9456 44.4603 31.869 44.1927 31.869C43.9098 31.869 43.776 31.9265 43.776 32.4446V39.7363H41.7507V29.9694H43.776V30.4874C44.0411 30.1037 44.478 29.8541 45.1219 29.8541C45.9376 29.8541 46.2785 30.0843 46.43 30.6793C46.7129 30.2187 47.1295 29.8541 47.8694 29.8541C49.1775 29.8541 49.3467 30.3531 49.3467 32.0992V39.7363H47.3189V32.4446Z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1911_12105",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 26,
    width: 64,
    height: 14
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8335 26.9195V39.9482H65.1668V26.9195",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1911_12105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.3416 39.793C54.2356 39.793 54.5942 38.8334 54.6522 36.7803L52.7381 36.6845C52.7381 37.7781 52.5866 37.9316 52.2659 37.9316C51.9426 37.9316 51.7911 37.7206 51.7911 36.838V35.6674H54.6699V32.8274C54.6699 30.7168 54.1219 29.8533 52.3416 29.8533C50.5411 29.8533 49.8391 30.5441 49.8391 32.8468V36.838C49.8391 38.8912 50.4073 39.793 52.3416 39.793ZM51.7911 32.8274C51.7911 31.9834 51.9426 31.7913 52.2836 31.7913C52.6447 31.7913 52.7583 31.9834 52.7583 32.8083V33.883H51.7911V32.8274Z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1911_12105",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 26,
    width: 64,
    height: 14
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8335 26.9195V39.9482H65.1668V26.9195",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1911_12105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.1265 29.9694H57.1896V30.4874C57.4547 30.1037 57.9295 29.8541 58.5936 29.8541C59.8815 29.8541 60.0507 30.4297 60.0507 32.0992V39.7363H57.985V32.4446C57.985 31.9456 57.8916 31.869 57.6265 31.869C57.3411 31.869 57.1896 31.9265 57.1896 32.4446V39.7363H55.1265V29.9694Z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1911_12105",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 26,
    width: 64,
    height: 14
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8335 26.9195V39.9482H65.1668V26.9195",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1911_12105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.374 29.966H60.922V27.5865H62.9498V29.966H63.6695V31.9231H62.9498V37.0656C62.9498 37.6798 63.1215 37.7758 63.5558 37.7758H63.6695V39.7324H62.9321C61.5281 39.7324 60.922 39.1569 60.922 37.5451V31.9228H60.374V29.966Z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1911_12105",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 26,
    width: 64,
    height: 14
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8335 26.9195V39.9482H65.1668V26.9195",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1911_12105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0488 28.3548C64.069 28.4125 64.1246 28.4892 64.1625 28.5469C64.2206 28.5852 64.2963 28.6427 64.3519 28.6619C64.4276 28.7002 64.5034 28.7002 64.5993 28.7002C64.6751 28.7002 64.7509 28.7002 64.8266 28.6619C64.9024 28.6427 64.9781 28.5852 65.016 28.5469C65.0741 28.4892 65.112 28.4125 65.1499 28.3548C65.1877 28.2782 65.2054 28.1821 65.2054 28.1055C65.2054 28.0094 65.1877 27.9328 65.1499 27.8559C65.112 27.7792 65.0741 27.7218 65.016 27.664C64.9781 27.6065 64.9024 27.5682 64.8266 27.5491C64.7531 27.5112 64.6718 27.4914 64.5892 27.4914C64.5067 27.4914 64.4254 27.5112 64.3519 27.5491C64.2814 27.5734 64.2168 27.6125 64.1625 27.664C64.1246 27.7218 64.069 27.7792 64.0488 27.8559C64.0105 27.9333 63.9915 28.0189 63.9933 28.1055C63.9933 28.1821 64.011 28.2782 64.0488 28.3548ZM64.1625 27.9136C64.1827 27.8559 64.2206 27.7984 64.2584 27.7601C64.2963 27.7218 64.3519 27.6832 64.4099 27.6449C64.4655 27.6257 64.5236 27.6065 64.5993 27.6065C64.6751 27.6065 64.7307 27.6257 64.7887 27.6449C64.8443 27.6832 64.9024 27.7218 64.9403 27.7601C64.9781 27.7984 65.016 27.8559 65.0337 27.9136C65.0539 27.9711 65.0741 28.0286 65.0741 28.1055C65.0741 28.163 65.0539 28.2398 65.0337 28.2973C65.0145 28.355 64.9825 28.4075 64.9403 28.4509C64.9024 28.4892 64.8443 28.5275 64.7887 28.5469C64.7307 28.5852 64.6751 28.5852 64.5993 28.5852C64.5236 28.5852 64.4655 28.5852 64.4099 28.5469C64.3519 28.5275 64.2963 28.4892 64.2584 28.4509C64.2206 28.4125 64.1827 28.3548 64.1625 28.2973C64.1448 28.2398 64.1246 28.163 64.1246 28.1055C64.1246 28.0286 64.1448 27.9711 64.1625 27.9136ZM64.6928 28.1438C64.7307 28.1438 64.7685 28.1246 64.7887 28.0863C64.8266 28.0672 64.8443 28.0286 64.8443 27.9711C64.8443 27.9328 64.8266 27.9136 64.8266 27.8945C64.8064 27.8559 64.7887 27.8367 64.7685 27.8367C64.7307 27.8176 64.713 27.7984 64.6751 27.7984C64.6549 27.7984 64.617 27.7792 64.5791 27.7792H64.3721V28.4125H64.5034V28.163H64.5615L64.713 28.4125H64.8443L64.6928 28.163V28.1438ZM64.5993 27.8945C64.6372 27.8945 64.6751 27.8945 64.6928 27.9136C64.6928 27.9328 64.713 27.9519 64.713 27.9711C64.713 28.0094 64.6928 28.0286 64.6751 28.048C64.6549 28.0672 64.617 28.0672 64.5615 28.0672H64.5034V27.8945H64.5993Z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1911_12105",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 26,
    width: 64,
    height: 14
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8335 26.9165V39.9453H65.1668V26.9165",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1911_12105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.594 37.0113H58.9349V38.7574H59.4829V39.0645H58.594V37.0113ZM61.8339 38.2968L61.4147 37.0113H61.7758L62.0031 37.8556L62.2506 37.0113H62.5713L62.1748 38.2776V39.0645H61.8339V38.2968ZM55.6748 37.0113H56.0157V37.6829L56.3768 37.0113H56.7178L56.339 37.6829L56.7556 39.0645H56.3945L56.0915 38.0666L56.0157 38.201V39.0645H55.6748V37.0113ZM53.0789 37.0113H54.0082V37.3183H53.44V37.7787H53.8945V38.0666H53.44V38.7574H54.0082V39.0645H53.0789V37.0113ZM50.6344 37.0113H51.546V37.3183H50.9753V37.7787H51.4501V38.0666H50.9753V38.7574H51.546V39.0645H50.6344V37.0113ZM47.4905 37.0113H47.8314L47.945 37.8939L48.0031 38.2968L48.0789 37.8939L48.2102 37.0113H48.5132L48.6647 37.8939L48.7228 38.2968L48.7784 37.8939L48.892 37.0113H49.2329L48.892 39.0645H48.5511L48.3617 37.7595L48.1546 39.0645H47.8137L47.4905 37.0113Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1911_12105",
    x: -77.1663,
    y: -53.0801,
    width: 222.333,
    height: 172.873,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.0784314 0 0 0 0 0.192157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1911_12105"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1911_12105",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1911_12105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEw);
export default __webpack_public_path__ + "static/media/icon-ew.a588158c1cb17c47501de9c1b8256263.svg";
export { ForwardRef as ReactComponent };